// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__2lv31","logo-spin":"styles_logo-spin__InN21"};